export const formatSubscriptionDate = (isoDate: string, locale: string = 'en-US'): string => {
  return new Date(isoDate).toLocaleDateString(locale, { month: 'short', day: 'numeric', year: 'numeric' });
};
